<template>
  <el-dialog title="新增参展品牌" :visible.sync="visible">
    <el-form :inline="true" :model="filters"
      style="display:flex;height:36px;margin-top: -20px;margin-bottom: 6px">
      <el-form-item style="width:100%;display:flex" label="品牌名称：">
        <el-input v-model="filters.keyWord" placeholder="请输入品牌名称" maxlength="20"/>
      </el-form-item>
      <el-form-item style="display:flex;width:100%;" label="品类：">
        <el-select filterable v-model="filters.brandTypeId" placeholder="请选择">
          <el-option :label="item.Name" :value="item.Id"
            v-for="(item,index) in brandTypearr" :key="index"/>
        </el-select>
      </el-form-item>
      <el-form-item style="display:flex;margin-right:0;">
        <el-button type="danger" @click="onSubmit()">查 询</el-button>
      </el-form-item>
    </el-form>
    <div>
      <!-- 查询参展品牌列表 -->
      <el-table :data="brandList" :row-key="getRowKeys" class="ban_tab" stripe border :header-cell-style="{background:'#bbbbbb'}"
        @selection-change="handleSelectionChange" style="height:auto;margin-top:10px">
        <el-table-column type="selection" :reserve-selection="true" align="center"/>
        <el-table-column prop="Name" label="品牌" align="center">
          <template scope="scope"> <span :title="scope.row.Name"> {{scope.row.Name}} </span> </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :total="total" :current-page="pageIndex" style="float:right;margin: 10px 0;"/>
    </div>
    <div slot="footer" style="text-align: center;">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="danger" @click="dataFormSubmit()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SelectBrandTypeBaseDataByCondition } from '../../api/newOss';
import { getSelectGoodsBrandByBrandType, AddBrands } from "../../api/api";
  export default {
    name: "addCommodity",
    props: ["guid"],
    data () {
      return {
        visible: false,
        addVisible: false,
        ids: '',
        brandList:[], // 列表list
        selectBrands:[],
        goodIdarr:[],
        brandTypearr: [],
        filters: {
          keyWord: "",
          brandTypeId: 0
        },
        pageIndex: 1, // 页码
        pageSize: 10, // 每页行数
        total: 1,
        page: 1
      }
    },
    methods: {
      getRowKeys (row) {
          return row.Id; // id为列表数据的唯一标识
      },
      // 初始化数据
      init () {
        this.visible = true
        this.filters = {
          keyWord: "",
          brandTypeId: 0
        }
        this.$nextTick(() => {
          this.getgoodlist()
        })
      },
      // 初始化列表数据
      getgoodlist(){
        var obj = {
          userId:localStorage.Id,
          guid: this.guid,
          keyWord: this.filters.keyWord,
          brandTypeId: this.filters.brandTypeId,
          pageIndex:this.pageIndex, // 页码
          pageSize:10
        }
        // 查询参展品牌列表
        getSelectGoodsBrandByBrandType(obj).then(data=>{
          if(data.ResultCode == 1){
              this.brandList = data.ResultObj
              // Id Name IsSelected
              this.total = data.RowsCount;
          }else{
            this.brandList = [];
            this.total = 0
          }
        })
      },
      // 确认
      dataFormSubmit () {
        if(this.goodIdarr.length == 0){
        this.$swal({
            text:"请选择参展品牌",
            type:"warning"
        })
        return false
        }
        var obj = {
          guid: this.guid,
          brands:this.goodIdarr.join(",")
        }
        AddBrands(obj).then(data=>{
          if(data.ResultCode == 1){
              this.getgoodlist()
              this.visible = false
              this.$emit('refreshDataList', this.selectBrands)
          }
        })
      },
      //查询
      onSubmit() {
        this.pageIndex = 1;
        this.getgoodlist();
      },
      //分页
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.getgoodlist()
      },
      // 复选框
      handleSelectionChange(val) {
        this.goodIdarr = [];
        val.forEach(element => {
          this.goodIdarr.push(element.Id);
        });
      },
      //获取品类
      getBrandType() {
        var obj = {
          userId: localStorage.Id
        };
        SelectBrandTypeBaseDataByCondition(obj).then(data => {
          if (data.ResultCode == 1) {
            this.brandTypearr = data.ResultObj;
            this.newpinleioptions = data.ResultObj;
            this.brandTypearr.unshift({
              Id: 0,
              Name: "全部"
            });
            console.log(this.brandTypearr, "this.brandTypearr");
          }
        });
      }
    },
    mounted() {
      this.getgoodlist();
      this.getBrandType();
    }
  }
</script>


// WEBPACK FOOTER //
// addExhibitorsBrand.vue?3ef987be